import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {NzModalService} from 'ng-zorro-antd/modal';
import {TranslocoService} from '@jsverse/transloco';
import {
  SecurityVerificationDialogComponent,
  type SecurityVerificationDialogData,
  type SecurityVerificationResult,
} from './security-verification-dialog.component';

/** 由 AppComponent 提供，以复用组件级 NzModalModule。 */
@Injectable()
export class SecurityVerificationService {
  private readonly modal = inject(NzModalService);
  private readonly transloco = inject(TranslocoService);

  async verify(data: SecurityVerificationDialogData): Promise<SecurityVerificationResult | null> {
    const ref = this.modal.create<SecurityVerificationDialogComponent, SecurityVerificationDialogData, SecurityVerificationResult>({
      nzTitle: this.transloco.translate('security_verification.title'),
      nzContent: SecurityVerificationDialogComponent,
      nzData: data,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: true,
      nzWidth: 520,
    });
    return (await firstValueFrom(ref.afterClose)) ?? null;
  }
}
